var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19C11.0317 19 10.1217 18.8162 9.27 18.4487C8.41833 18.0812 7.6775 17.5825 7.0475 16.9525C6.4175 16.3225 5.91875 15.5817 5.55125 14.73C5.18375 13.8783 5 12.9683 5 12C5 11.0317 5.18375 10.1217 5.55125 9.27C5.91875 8.41833 6.4175 7.6775 7.0475 7.0475C7.6775 6.4175 8.41833 5.91875 9.27 5.55125C10.1217 5.18375 11.0317 5 12 5C12.9683 5 13.8783 5.18375 14.73 5.55125C15.5817 5.91875 16.3225 6.4175 16.9525 7.0475C17.5825 7.6775 18.0812 8.41833 18.4487 9.27C18.8162 10.1217 19 11.0317 19 12C19 12.9683 18.8162 13.8783 18.4487 14.73C18.0812 15.5817 17.5825 16.3225 16.9525 16.9525C16.3225 17.5825 15.5817 18.0812 14.73 18.4487C13.8783 18.8162 12.9683 19 12 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/Circle.8f4c09376ddb3240e72f910cebce18a9.svg";
export { ForwardRef as ReactComponent };